"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AnswerEvaluation;
(function (AnswerEvaluation) {
    AnswerEvaluation["NA"] = "na";
    AnswerEvaluation["TRUE"] = "true";
    AnswerEvaluation["FALSE"] = "false";
})(AnswerEvaluation = exports.AnswerEvaluation || (exports.AnswerEvaluation = {}));
var ResponseType;
(function (ResponseType) {
    ResponseType["VIDEO"] = "video";
    ResponseType["AUDIO"] = "audio";
    ResponseType["TEXT"] = "text";
    ResponseType["IMAGE"] = "image";
    ResponseType["SINGLE_SELECT"] = "singleSelect";
    ResponseType["MULTIPLE_SELECT"] = "multipleSelect";
    ResponseType["MATCH_THE_FOLLOWING"] = "matchTheFollowing";
    ResponseType["FILL_IN_THE_BLANKS"] = "fillInTheBlanks";
    ResponseType["EMPTY"] = "";
    ResponseType["OPINION_SCALE"] = "opinionScale";
    ResponseType["FILE"] = "file";
})(ResponseType = exports.ResponseType || (exports.ResponseType = {}));
var EvaluateResultType;
(function (EvaluateResultType) {
    EvaluateResultType["APPROVED"] = "approved";
    EvaluateResultType["REJECTED"] = "rejected";
})(EvaluateResultType = exports.EvaluateResultType || (exports.EvaluateResultType = {}));
var ILTLearnerType;
(function (ILTLearnerType) {
    ILTLearnerType["NONE"] = "none";
    ILTLearnerType["PUBLISHER"] = "publisher";
    ILTLearnerType["VIEWER"] = "viewer";
})(ILTLearnerType = exports.ILTLearnerType || (exports.ILTLearnerType = {}));
var ContentType;
(function (ContentType) {
    ContentType["GENERIC"] = "generic";
    ContentType["COURSE"] = "course";
    ContentType["CURRICULUM"] = "curriculum";
    ContentType["CHANNEL"] = "channel";
    ContentType["CHANNEL_CARD"] = "channelCard";
    ContentType["CHECKPOINT"] = "checkpoint";
    ContentType["ILT"] = "liveTraining";
    ContentType["LEARNING_CARD"] = "learningCard";
    ContentType["ASSIGNMENT_CARD"] = "assignmentCard";
    ContentType["CARD_QUESTION"] = "cardQuestion";
    ContentType["PEER_QUESTION"] = "peerQuestion";
    ContentType["PEER_REVIEW_CARD"] = "peerReviewCard";
    ContentType["CARD_QUESTION_FOR_REVIEW"] = "cardQuestionForReview";
    ContentType["SECTION"] = "section";
    ContentType["SKILL"] = "skill";
    ContentType["ILT_SESSION"] = "liveTrainingSession";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
var StateContentType;
(function (StateContentType) {
    StateContentType["GENERIC"] = "generic";
    StateContentType["OFFER"] = "offer";
    StateContentType["CURRICULUM_OFFER"] = "curriculumOffer";
    StateContentType["CHANNEL"] = "channel";
    StateContentType["CHANNEL_CARD"] = "channelCard";
    StateContentType["CHECKPOINT"] = "checkpoint";
    StateContentType["ILT"] = "liveTraining";
    StateContentType["LIVE_TRAINING_SESSION"] = "liveTrainingSession";
    StateContentType["LEARNING_CARD"] = "learningCard";
    StateContentType["ASSIGNMENT_CARD"] = "assignmentCard";
    StateContentType["CARD_QUESTION"] = "cardQuestion";
    StateContentType["PEER_QUESTION"] = "peerQuestion";
    StateContentType["PEER_REVIEW_CARD"] = "peerReviewCard";
    StateContentType["CARD_QUESTION_FOR_REVIEW"] = "cardQuestionForReview";
    StateContentType["SECTION"] = "section";
    StateContentType["SKILL"] = "skill";
})(StateContentType = exports.StateContentType || (exports.StateContentType = {}));
var EnrolmentContentType;
(function (EnrolmentContentType) {
    EnrolmentContentType["OFFER"] = "offer";
    EnrolmentContentType["CURRICULUM_OFFER"] = "curriculumOffer";
    EnrolmentContentType["CHECKPOINT"] = "checkpoint";
    EnrolmentContentType["ILT"] = "liveTraining";
    EnrolmentContentType["SKILL"] = "skill";
})(EnrolmentContentType = exports.EnrolmentContentType || (exports.EnrolmentContentType = {}));
var CompletionStatus;
(function (CompletionStatus) {
    CompletionStatus["INCOMPLETE"] = "inComplete";
    CompletionStatus["COMPLETE"] = "complete";
    CompletionStatus["NOT_ATTEMPTED"] = "notAttempted";
})(CompletionStatus = exports.CompletionStatus || (exports.CompletionStatus = {}));
var ILTProgressStatus;
(function (ILTProgressStatus) {
    ILTProgressStatus["COMPLETED"] = "completed";
    ILTProgressStatus["REGISTERED"] = "registered";
    ILTProgressStatus["NOT_REGISTERED"] = "notRegistered";
})(ILTProgressStatus = exports.ILTProgressStatus || (exports.ILTProgressStatus = {}));
var CompletionCriteria;
(function (CompletionCriteria) {
    CompletionCriteria["MIN_PROGRESS_MEASURE"] = "minProgressMeasure";
    CompletionCriteria["ACTUAL_SUBMIT"] = "actualSubmit";
})(CompletionCriteria = exports.CompletionCriteria || (exports.CompletionCriteria = {}));
var CheckpointSubmissionStatus;
(function (CheckpointSubmissionStatus) {
    CheckpointSubmissionStatus["APPROVED"] = "approved";
    CheckpointSubmissionStatus["PENDING"] = "pending";
    CheckpointSubmissionStatus["NOT_ATTEMPTED"] = "notAttempted";
    CheckpointSubmissionStatus["REJECTED"] = "rejected";
})(CheckpointSubmissionStatus = exports.CheckpointSubmissionStatus || (exports.CheckpointSubmissionStatus = {}));
var CheckpointSuccessStatus;
(function (CheckpointSuccessStatus) {
    CheckpointSuccessStatus["PASS"] = "pass";
    CheckpointSuccessStatus["NA"] = "na";
    CheckpointSuccessStatus["FAIL"] = "fail";
})(CheckpointSuccessStatus = exports.CheckpointSuccessStatus || (exports.CheckpointSuccessStatus = {}));
var SuccessStatus;
(function (SuccessStatus) {
    SuccessStatus["PASS"] = "pass";
    SuccessStatus["FAIL"] = "fail";
    SuccessStatus["NOT_APPLICABLE"] = "na";
})(SuccessStatus = exports.SuccessStatus || (exports.SuccessStatus = {}));
var ContentSubType;
(function (ContentSubType) {
    ContentSubType["HTML"] = "html";
    ContentSubType["PDF"] = "pdf";
    ContentSubType["VIDEO"] = "video";
    ContentSubType["AUDIO"] = "audio";
    ContentSubType["SCORM"] = "scorm";
    ContentSubType["PEERREVIEW"] = "peerReview";
    ContentSubType["ASSIGNMENT"] = "assignment";
    ContentSubType["BLOCKS"] = "blocks";
    ContentSubType["OBJECTIVE"] = "objective";
    ContentSubType["SURVEY"] = "survey";
})(ContentSubType = exports.ContentSubType || (exports.ContentSubType = {}));
var ILTRegisterType;
(function (ILTRegisterType) {
    ILTRegisterType["ENROLLED"] = "enrolled";
    ILTRegisterType["ASSIGNED"] = "assigned";
    ILTRegisterType["NOT_REGISTERED"] = "notRegistered";
    ILTRegisterType["WAITLISTED"] = "waitListed";
})(ILTRegisterType = exports.ILTRegisterType || (exports.ILTRegisterType = {}));
var SessionRegisterType;
(function (SessionRegisterType) {
    SessionRegisterType["ENROLLED"] = "enrolled";
    SessionRegisterType["ASSIGNED"] = "assigned";
    SessionRegisterType["NOT_REGISTERED"] = "notRegistered";
    SessionRegisterType["WAITLISTED"] = "waitListed";
})(SessionRegisterType = exports.SessionRegisterType || (exports.SessionRegisterType = {}));
var InteractionType;
(function (InteractionType) {
    InteractionType["PeerReview"] = "peerReview";
    InteractionType["Evaluation"] = "evaluation";
    InteractionType["Grade"] = "grade";
    InteractionType["Feedback"] = "feedback";
})(InteractionType = exports.InteractionType || (exports.InteractionType = {}));
var ActorType;
(function (ActorType) {
    ActorType["USER"] = "user";
    ActorType["MANAGER"] = "manager";
    ActorType["ADMIN"] = "admin";
    ActorType["TEACHER"] = "teacher";
})(ActorType = exports.ActorType || (exports.ActorType = {}));
var AssignType;
(function (AssignType) {
    AssignType["ENROLLED"] = "enrolled";
    AssignType["ASSIGNED"] = "assigned";
    AssignType["AUTO_ASSIGNED"] = "autoAssign";
})(AssignType = exports.AssignType || (exports.AssignType = {}));
var AssignAction;
(function (AssignAction) {
    AssignAction["COURSE"] = "course";
    AssignAction["CURRICULUM"] = "curriculum";
    AssignAction["CHECKPOINT"] = "checkPoint";
    AssignAction["ILT"] = "liveTraining";
})(AssignAction = exports.AssignAction || (exports.AssignAction = {}));
var AvailableOnType;
(function (AvailableOnType) {
    AvailableOnType["FIXED"] = "fixed";
    AvailableOnType["DYNAMIC"] = "dynamic";
    AvailableOnType["RELATIVE"] = "relative";
    AvailableOnType["IMMEDIATE"] = "immediate";
})(AvailableOnType = exports.AvailableOnType || (exports.AvailableOnType = {}));
var DueDateType;
(function (DueDateType) {
    DueDateType["FIXED"] = "fixed";
    DueDateType["NO_DUE_DATE"] = "noDueDate";
    DueDateType["DYNAMIC"] = "dynamic";
    DueDateType["RELATIVE"] = "relative";
    DueDateType["CONTENT_DEPENDENT"] = "contentDependent";
})(DueDateType = exports.DueDateType || (exports.DueDateType = {}));
var ReviewerType;
(function (ReviewerType) {
    ReviewerType["NONE"] = "none";
    ReviewerType["MANAGER"] = "manager";
    ReviewerType["USER"] = "user";
    ReviewerType["GROUP"] = "group";
})(ReviewerType = exports.ReviewerType || (exports.ReviewerType = {}));
var ContentStatus;
(function (ContentStatus) {
    ContentStatus["ACTIVE"] = "active";
    ContentStatus["DELETED"] = "deleted";
})(ContentStatus = exports.ContentStatus || (exports.ContentStatus = {}));
//# sourceMappingURL=entity.js.map